import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AdminCyclesComponent } from './cursus/admin.cycles.component';
//////import { ConfigComponent } from './configuration/config.component';
import { SharedPipeModule } from '../pipes/shared-pipe-module';
import { AdminCatalogsComponent } from './catalogs/admin.catalogs.component';
import { AdminCatalogsService } from './catalogs/admin.catalogs.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedPipeModule
  ],
  providers: [
    AdminCatalogsService
  ],
  declarations: [
    AdminCatalogsComponent,
    AdminCyclesComponent
    //////ConfigComponent
  ]
})

export class AdminModule { }
